// Sign out, as an icon button: for pages shown without the app's navigation.
import { useContext } from "react";

import { UserContext } from "../auth";
import icon from "./IconButton.module.css";

export const SignOutButton = () => {
  const { user, logout } = useContext(UserContext);
  if (!logout) return null;
  const label = user?.email ? `Sign out ${user.email}` : "Sign out";
  return (
    <button
      type="button"
      className={icon.iconButton}
      aria-label={label}
      title={label}
      onClick={() => logout()}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M15 8l4 4-4 4M19 12H9"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
